import { Component, ChangeDetectionStrategy } from '@angular/core';

import { VersionDisplayBaseComponent } from '@ups/xplat/features';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-version-display',
  templateUrl: 'version-display.component.html',
  standalone: false,
})
export class VersionDisplayComponent extends VersionDisplayBaseComponent {}
